module.exports = __webpack_public_path__ + "img/gys_16@2x.60d905c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/cooperation/gys_16@2x.png
// module id = 30xA
// module chunks = 0